import Jumbotron from './Jumbotron/Jumbotron';
import Heading from './Heading/Heading';
// import JumbotronCarousel from './JumbotronCarousel/JumbotronCarousel';

export default {
  jumbotron: {
    standard: Jumbotron
  },
  heading: {
    standard: Heading
  }
  // 'jumbotron-carousel': {
  //   standard: JumbotronCarousel
  // }
};
